function ConferenceForm(containerObject) {
	/* THIS FIX */
	var _this = this;

	/* PRIVATE CONSTANTS */


	/* PRIVATE VARIABLES */
	var submitEnabled = true;
	var form;
	var submitBtn;
	var recaptchaToken = null;


	/* PUBLIC PROPERTIES */
	this.container = null;
	this.inited = false;


	/* PRIVATE FUNCTIONS */
	function _construct() {
		_this.container = containerObject;
		_this.init();
	}


	function showAlert(message) {
		alert(message);
	}


	function onFormSendSuccess(data) {
		$('.state.form', _this.container).hide();
		$('.state.success', _this.container).show();
		_this.resetForm();
	}


	function onFormSendError(errorCode) {
		switch (errorCode) {
			case 1:
				// captcha
				showAlert(form.data('message-error-captcha'));
				break;
				
			case 2:
				// already subscribed
				showAlert(form.data('message-error-subscribed'));
				break;

			default:
				// default
				showAlert(form.data('message-error-form'));
				break;
		}
		/*
		getRecaptchaToken();
		*/
	}


	function handleConditionalInputDietary(){
		 var radioButtons = _this.container[0].querySelectorAll('input[name="dietary_restrictions"]');
		 var inputDetails = _this.container[0].querySelector('input[name="dietary_restrictions_detail"]');

		radioButtons.forEach(function(radioButton) {
			radioButton.addEventListener('change', function () {
				if (this.value === 'yes') {
					inputDetails.parentNode.classList.remove('hidden');
				} else {
					inputDetails.parentNode.classList.add('hidden');
					inputDetails.value = '';
				}
			});
		});
	}


	function initFormHandler() {
		var messageFieldInvalid = form.data('message-field-invalid');
		var messageFieldEmailInvalid = form.data('message-field-email-invalid');
		var messageFieldAgreementInvalid = form.data('message-field-agreement-invalid');

		form.validate({
			rules: {
				agreement: {
					required: function (element) {
						return element;
					}
				},
				dietary_restrictions_detail: {
					required: function (element) {
						return $('#dietary_restrictions_opt_2', _this.container).is(":checked");
					}
				}
			},
			messages: {
				first_name: {
					required: messageFieldInvalid
				},
				last_name: {
					required: messageFieldInvalid
				},
				email: {
					required: messageFieldEmailInvalid,
					email: messageFieldEmailInvalid
				},
				agreement: {
					required: messageFieldAgreementInvalid
				}
			},

			errorPlacement: function(label, element) {
				label.addClass('error');
				var inputName = element.attr('name');
				
				switch(inputName){
					case 'phd_student':
					case 'conference_days':
					case 'conference_dinner':
					case 'dietary_restrictions':
						// append after radio group
						element.parent().parent().parent().append(label);
						break;
						
					default: 
						// other inputs
						element.parent().append(label);
						break;
				}
			},

			submitHandler: function (f) {
				if (submitEnabled) {
					submitEnabled = false;
					submitBtn.addClass('loading');
					var url = form.attr('action');
					var data = form.serializeArray();
					data.push({ name: "formAction", value: "submit" });
					data.push({ name: "recaptchaToken", value: recaptchaToken });

					$.post(url, data, function (result) {
						if (result.status === 1) {
							onFormSendSuccess(data);
						} else {
							onFormSendError(result.errorCode);
							submitEnabled = true;
							submitBtn.removeClass('loading');
						}
					});
				}
			}
		});
	}


	function getRecaptchaToken() {
		grecaptcha.execute(recaptchaSiteKey, { action: 'conference_form' })
			.then(function (token) {
				recaptchaToken = token;
			});
	}


	/* PUBLIC FUNCTIONS */
	this.init = function () {
		if (!_this.inited) {
			// object references
			form = $('form', _this.container);
			submitBtn = $('#btn-submit', form);

			// handlers
			handleConditionalInputDietary();

			// init
			initFormHandler();

			/*
			grecaptcha.ready(function () {
				getRecaptchaToken();
			});
			*/

			_this.inited = true;
		}
	};


	this.resetForm = function () {
		form[0].reset();
	};


	/* INIT CONSTRUCTOR */
	_construct();
}


/* PUBLIC CONSTANTS */
